module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/layers-e1960009647cd6ab7063c97ca3fb2301.svg";